import { render, staticRenderFns } from "./card-stack-carousel.vue?vue&type=template&id=442f594b&scoped=true"
import script from "./card-stack-carousel.vue?vue&type=script&lang=js"
export * from "./card-stack-carousel.vue?vue&type=script&lang=js"
import style0 from "./card-stack-carousel.vue?vue&type=style&index=0&id=442f594b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f594b",
  null
  
)

export default component.exports